import { CSSProperties, ReactNode } from 'react';

import { useIsLmmSidepanelSelected, useSetSidepanelLmmVoorraad } from '@/apps/lmm/state/selectors/useLmmSidepanelStore';

import { LmmTijdstip, LmmVerrijktV2 } from '../../types/LmmVoorraad';

import styles from './LmmSidepanelToggle.module.css';
type LmmSidepanelToggleProps = {
  children: ReactNode;
  lmmVoorraad: LmmVerrijktV2;
  lmmTijdstip: LmmTijdstip;
  style: CSSProperties;
  className: string;
};
export default function LmmSidepanelToggle({
  children,
  lmmVoorraad,
  lmmTijdstip,
  style,
  className,
}: LmmSidepanelToggleProps) {
  const isSelected = useIsLmmSidepanelSelected(lmmVoorraad.materieel, lmmTijdstip.label);
  const setShowSidepanel = useSetSidepanelLmmVoorraad();

  return (
    <div
      className={[styles.sidepanelToggleContainer, isSelected ? styles.selected : '', className].join(' ')}
      style={style}
    >
      <a
        role='button'
        href=''
        data-testid={`lmmSidepanelToggle-${lmmVoorraad.materieel}-${lmmTijdstip.label}`}
        className={styles.sidepanelToggleAnchor}
        onClick={(event) => {
          event.preventDefault();
          setShowSidepanel(lmmVoorraad, lmmTijdstip);
        }}
      >
        {children}
      </a>
    </div>
  );
}
